import o from "./index192.js";
/* empty css         */
import r from "./index130.js";
const e = /* @__PURE__ */ r(o, [["__scopeId", "data-v-e429ffd3"]]);
export {
  e as default
};
